import { render, staticRenderFns } from "./TermsAndPrivacyComponent.component.html?vue&type=template&id=1f41169a&"
import script from "./TermsAndPrivacyComponent.component.ts?vue&type=script&lang=ts&"
export * from "./TermsAndPrivacyComponent.component.ts?vue&type=script&lang=ts&"
import style0 from "./TermsAndPrivacyComponent.component.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports